import { validateEmail } from "./index";

export const validEmail = email => validateEmail(email);
export const required = val => !!val || "Field is required.";
export const minPasswordLength = val => val.length >= 8 || "Min 8 characters";
export const zipCodeRule = val => {
  const reGX = /^[0-9]{5}([- /]?[0-9]{4})?$/;
  return reGX.test(val) || "Please Enter a valid zipcode";
};
